import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
// import { DataSet, Network } from 'vis-network';

import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import _ from "lodash";
import "materialize-css";
import {
  catchError,
  EMPTY,
  interval,
  Subject,
  switchMap,
  takeUntil,
} from "rxjs";
import * as vis from "vis";
import { TestCaseGeneratorActions } from "../../../core/ngrx/actions/testcase-generator.actions";
import { ProjectService } from "../../../core/services/project/project.service";
import { RestService } from "../../../core/services/rest.service";
import { TcgService } from "../../../core/services/tcg.service";
import { ToasterService } from "../../../core/services/toaster-service";
import { userStoryConfirmationTableColumns } from "../../../core/table-templates/user-story-table";
import { MessageEnum } from "../../../core/utils/message.enum";
import { LoadingComponent } from "../../common/loading/loading.component";
import { ProgressBarComponent } from "../../common/progress-bar/progress-bar.component";
import { ChecklistTreeModalComponent } from "../../modal-templates/checklist-tree-modal/checklist-tree-modal.component";
import { UserConfirmationModalComponent } from "../../modal-templates/user-confirmation-modal/user-confirmation-modal.component";

@Component({
  selector: "app-knowledge-graph",
  standalone: true,
  imports: [CommonModule, FormsModule, LoadingComponent, ProgressBarComponent],
  templateUrl: "./knowledge-graph.component.html",
  styleUrl: "./knowledge-graph.component.scss",
})
export class KnowledgeGraphComponent implements AfterViewInit {
  @Input() isAgentic: boolean = false;

  @Input() data: any;

  dataSet: any = {
    nodes: [],
    edges: [],
  };
  activeType = "storyDriven";
  filterData: any = {
    userStory: "",
    weight: "",
  };

  isExpanded = true;
  filterOptions: any = {
    userStories: [],
    weights: [],
  };

  visOptions = {
    navigationButtons: true,
    interaction: {
      hover: true,
      edges: {
        arrows: "to",
        shadow: true,
      },
    },
  };
  //     edges: {
  //     arrows: {
  //       to: {
  //         enabled: true,
  //         scaleFactor: 0.5,
  //       },
  //     },
  //     shadow: true,
  //     smooth: {
  //       enabled: true,
  //       type: 'continuous',
  //       roundness: 0.5,
  //     },
  //   },
  // };
  clonedData: any = {};
  isLoading = false;
  isDownloading = false;
  colors: any = [
    { color: "darkcyan" },
    { color: "green" },
    { color: "blue" },
    { color: "burlywood" },
    { color: "blueviolet" },
    { color: "purple" },
    { color: "crimson" },
    { color: "teal" },
    { color: "tomato" },
    { color: "gold" },
    { color: "orange" },
    { color: "darkorange" },
    { color: "deeppink" },
    { color: "mediumseagreen" },
    { color: "seagreen" },
    { color: "slateblue" },
    { color: "steelblue" },
    { color: "lightseagreen" },
    { color: "coral" },
    { color: "firebrick" },
    { color: "darkslategray" },
    { color: "darkolivegreen" },
    { color: "indianred" },
    { color: "khaki" },
    { color: "lightcoral" },
    { color: "mediumorchid" },
    { color: "mediumturquoise" },
    { color: "navy" },
    { color: "olive" },
    { color: "orchid" },
    { color: "peru" },
    { color: "rosybrown" },
    { color: "salmon" },
    { color: "sienna" },
    { color: "springgreen" },
    { color: "turquoise" },
    { color: "violet" },
  ];
  storyTypes: any = {
    Functional: "functional",
    Smoke: "functional_smoke",
    Sanity: "functional_sanity",
    Regression: "functional_regression",
    "Non functional": "non_functional",
  };
  selectedUserStoryType: any;

  colorsByType: any = {};
  projectId: string = "";
  versionId: string = "";

  stopPolling$ = new Subject<void>();
  destroy$ = new Subject<void>();

  progressText: string = "";
  percentage: number = 0;
  displayProgress = false;
  isProgressError = false;
  configId: string = "";
  selectedStories: any = [];

  /**
   * Emits an event to move to the next tab.
   * @type {EventEmitter<void>}
   */
  @Output() moveToNextTabEvent = new EventEmitter<void>();

  /**
   * Emits an event to enable specific tabs.
   * @type {EventEmitter<number[]>}
   */
  @Output() enableTabsEvent = new EventEmitter<number[]>();

  @ViewChild("networkContainer") networkContainer!: ElementRef;
  networkInstance: vis.Network | undefined;

  private modalService = inject(NgbModal);
  selectedRows: any;
  deselectedRows: any;
  isSelectedAll: boolean = false;
  deSelectedStoryKeys: any;

  constructor(
    private readonly projectService: ProjectService,
    private readonly restService: RestService,
    private readonly tcgService: TcgService,
    private store: Store,
    private readonly toaster: ToasterService
  ) {}

  ngOnInit() {
    if(!this.isAgentic) {
      this.isLoading = true;
      this.configId = this.tcgService.getConfigId();
      this.selectedStories = this.tcgService.getStoryKeys();
      this.tcgService.getSelectedRows().subscribe((res: any) => {
        this.selectedRows = res;
      });

      this.tcgService.getDeSelectedRows().subscribe((res: any) => {
        this.deselectedRows = res;
      });

      this.tcgService.getSelectedStatus().subscribe((res: any) => {
        this.isSelectedAll = res;
      });

      this.projectService.getProjectId().subscribe((res: any) => {
        this.projectId = res;
        this.deSelectedStoryKeys = this.deselectedRows.map(
          (item: any) => item.storyId
        );

        const payload = {
          selectedStoryKeys: this.selectedStories,
          selectedAll: this.isSelectedAll,
          excludedStoryKeys: this.deSelectedStoryKeys,
        };
        this.restService
          .getKgNodes(this.projectId, this.configId, payload)
          .subscribe((res: any) => {
            this.isLoading = false;
            if (res.data?.status === "COMPLETED") {
              this.onNodesResponseReceived(res);
              this.getUnifiedNodes();
            } else {
              this.progressText = res?.data?.message || "Initializing";
              this.getNodesAsync();
            }
          });
      });
    }
  }

  ngAfterViewInit() {
    if(this.isAgentic) {
      console.log("Agentic KG Data-->", this.data);
      this.onNodesResponseReceived(this.data);
    }
  }

  getNodesAsync() {
    this.displayProgress = true;
    this.percentage = 5;
    const payload = {
      selectedStoryKeys: this.selectedStories,
      selectedAll: this.isSelectedAll,
      excludedStoryKeys: this.deSelectedStoryKeys,
    };
    interval(5000)
      .pipe(
        switchMap(() =>
          this.restService.getKgNodes(
            this.projectId,
            this.configId,
            payload
          )
        ),
        takeUntil(this.stopPolling$),
        takeUntil(this.destroy$),
        catchError(() => {
          this.progressText = "Error occured while generating graph";
          return EMPTY;
        })
      )
      .subscribe((res: any) => {
        if (res.data?.status === "FAILED") {
          this.progressText = res?.data?.error || res?.data?.message;
          this.isProgressError = true;
          this.stopPolling$.next();
        } else if (res.data?.status !== "COMPLETED") {
          this.progressText = res?.data?.message || "Processing graph nodes";
          if (this.percentage + 15 < 90) this.percentage += 15;
        } else {
          this.stopPolling$.next();
          this.progressText = "Process completed";
          this.onNodesResponseReceived(res);
          this.getUnifiedNodes(!res?.data?.nodes?.length);
          setTimeout(() => {
            this.displayProgress = false;
          }, 1000);
          this.percentage = 100;
        }
      });
  }

  getUnifiedNodes(setActive: boolean = false) {
    this.isLoading = true;
    this.restService.getUnifiedKgNodes(this.projectId, this.configId).subscribe(
      (res: any) => {
        this.clonedData.appContext = _.cloneDeep(res.data);
        if (setActive) {
          this.dataSet = res.data;
          this.activeType = "appContext";
          this.populateGraph();
        }
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  onNodesResponseReceived(res: any) {
    this.clonedData.storyDriven = _.cloneDeep(res.data);
    this.dataSet = res.data;
    if (this.dataSet.nodes?.length) {
      this.activeType = "storyDriven";
      this.populateFilters();
      this.populateGraph();
    }
  }

  populateGraph() {
    this.networkInstance?.redraw();
    const nodes = new vis.DataSet<any>(
      this.dataSet.nodes.map((ele: any) => {
        let clr = this.colorsByType[ele.type] || this.getRandomColor(ele.type);
        return {
          ...ele,
          shape: "dot",
          title: ele?.properties?.user_story_id
            ? `[${ele?.properties?.user_story_id}] ${ele?.properties?.description}`
            : `${ele?.properties?.description}`,
          size: 8,
          color: clr,
          font: {
            size: 10,
            bold: true,
          },
        };
      })
    );
    const edges = new vis.DataSet<any>(
      this.dataSet.edges.map((ele: any) => {
        return {
          ...ele,
          from: ele.source,
          to: ele.target,
          label: ele.relationship,
          title: ele?.properties?.name,
          font: {
            size: 8,
            color: "#808080",
          },
          arrows: {
            to: {
              enabled: true,
              scaleFactor: 0.5,
            },
          },
        };
      })
    );

    const data = { nodes, edges };

    this.networkInstance = new vis.Network(
      this.networkContainer.nativeElement,
      data,
      this.visOptions
    );
  }

  populateFilters() {
    this.dataSet.nodes.forEach((node: any) => {
      const rawId = node.properties?.user_story_id;
      const storyIds: string[] = rawId
        ? (Array.isArray(rawId) ? rawId : [rawId])
        : [];

      storyIds.forEach((storyId: string) => {
        if (storyId && (this.selectedStories.includes(storyId) || this.isSelectedAll)) {
          const obj = this.filterOptions.userStories.find(
            (ele: any) => storyId === ele.value
          );
          if (!obj) {
            this.filterOptions.userStories.push({
              label: storyId,
              value: storyId,
            });
          }
        }
      });

      let weightObj = this.filterOptions.weights.find(
        (ele: any) =>
          node.properties?.weight?.low == ele.value.split(",")[0] &&
          node.properties?.weight?.high == ele.value.split(",")[1]
      );
      if (!weightObj) {
        this.filterOptions.weights.push({
          label: `Low: ${node.properties?.weight?.low}, High: ${node.properties?.weight?.high}`,
          value:
            node.properties?.weight?.low + "," + node.properties?.weight?.high,
        });
      }
    });
  }

  onTypeSelect(type: string) {
    if (this.activeType === type) {
      return;
    }
    this.filterData.userStory = "";
    this.filterData.weights = "";
    this.colors.forEach((ele: any) => {
      delete ele.used;
    });

    this.activeType = type;
    this.dataSet = this.clonedData[type];
    if (type !== "appContext") this.populateFilters();
    this.populateGraph();
  }

  expand() {
    this.isExpanded = !this.isExpanded;
  }

  onFilterChange(type: string) {
    let data: any = {};
    let filteredNodes: any = [];
    let filteredEdges: any = [];
    let nodes: any = [];
    let edges: any = [];

    if (type === "userStories") {
      this.filterData.weight = "";
      filteredNodes = this.filterData.userStory
        ? this.clonedData[this.activeType].nodes.filter((node: any) => {
            const rawId = node?.properties?.user_story_id;
            const storyIds: string[] = rawId
              ? (Array.isArray(rawId) ? rawId : [rawId])
              : [];
            return storyIds.includes(this.filterData.userStory);
          })
        : this.clonedData[this.activeType].nodes;
      nodes = new vis.DataSet<any>(
        filteredNodes.map((ele: any) => {
          return {
            ...ele,
            shape: "dot",
            title: ele?.properties?.description,
            color: this.colorsByType[ele.type] || this.getRandomColor(ele.type),
            size: 8,
            font: {
              size: 10,
              bold: true,
            },
          };
        })
      );
    }

    if (type === "weight") {
      this.filterData.userStory = "";
      filteredNodes = this.filterData.weight
        ? this.clonedData[this.activeType].nodes.filter(
            (node: any) =>
              node?.properties?.weight?.low ===
                JSON.parse(this.filterData.weight.split(",")[0]) &&
              node?.properties?.weight?.high ===
                JSON.parse(this.filterData.weight.split(",")[1])
          )
        : this.clonedData[this.activeType].nodes;
      nodes = new vis.DataSet<any>(
        filteredNodes.map((ele: any) => {
          return {
            ...ele,
            shape: "dot",
            title: ele?.properties?.description,
            color: this.colorsByType[ele.type] || this.getRandomColor(ele.type),
            size: 8,
            font: {
              size: 10,
              bold: true,
            },
          };
        })
      );
    }

    this.clonedData[this.activeType].edges.forEach((edge: any) => {
      if (
        filteredNodes.find(
          (node: any) => node.id === (edge.source || edge.target)
        )
      ) {
        filteredEdges.push(edge);
      }
    });
    edges = new vis.DataSet<any>(
      filteredEdges.map((ele: any) => {
        return {
          ...ele,
          from: ele.source,
          to: ele.target,
          label: ele.relationship,
          title: ele?.properties?.name,
          font: {
            size: 8,
            color: "#808080",
          },
          arrows: {
            to: {
              enabled: true,
              scaleFactor: 0.5,
            },
          },
        };
      })
    );

    data = { nodes, edges };
    this.networkInstance = new vis.Network(
      this.networkContainer.nativeElement,
      data,
      this.visOptions
    );
  }

  /**
   * Moves to the next tab.
   */
  moveToNextTab() {
    this.moveToNextTabEvent.emit();
  }

  generate() {
    let modalRef = this.modalService.open(ChecklistTreeModalComponent, {
      centered: true,
      backdrop: "static",
    });
    modalRef.result.then((result: any) => {
      if (result) {
        console.log("selected test types->", this.storyTypes[result.value[0]]);
        this.selectedUserStoryType = this.storyTypes[result.value[0]];
        this.onGenerate();
      }
    });
  }

  /**
   * Triggers the test case generation process.
   */
  onGenerate() {
    if (!this.selectedRows) {
      this.toaster.pop({
        type: "error",
        text: MessageEnum.DATA_SELECTION_NONE,
      });
      return;
    }

    const incompleteStories = this.selectedRows.filter(
      (story: any) =>
        !story.summary?.trim() ||
        !story.description?.trim() ||
        !story.acceptanceCriteria?.trim()
    );

    const completeStories = this.selectedRows.filter(
      (story: any) =>
        story.summary?.trim() &&
        story.description?.trim() &&
        story.acceptanceCriteria?.trim()
    );

    if (incompleteStories.length === 0) {
      this.generateTestCases();
    } else {
      this.onGenerateConfirmation(incompleteStories, completeStories);
    }
  }

  generateTestCases() {
    // Filter selected stories and extract the "key" values into an array
    const selectedStoryKeys = this.selectedRows
      .filter((item: any) => item.select)
      .map((item: any) => item.storyId);

    const deSelectedStoryKeys = this.deselectedRows.map(
      (item: any) => item.storyId
    );

    this.tcgService.setStoryKeys(selectedStoryKeys);
    this.projectService.clearTestCaseVersionId();
    const selectedStories = {
      projectId: this.projectId,
      configId: this.configId,
      selectedStoryKeys: selectedStoryKeys,
      excludedStoryKeys: deSelectedStoryKeys,
      selectedAll: this.isSelectedAll,
      testCaseType: this.selectedUserStoryType,
    };
    this.store.dispatch(
      TestCaseGeneratorActions.generateTestCases({
        selectedUserStories: selectedStories,
      })
    );
    this.moveToNextTab();
    this.enableTabsEvent.emit([2]);
  }

  onGenerateConfirmation(incompleteStories: any, selectedStories: any) {
    let modalRef = this.modalService.open(UserConfirmationModalComponent, {
      centered: true,
      size: "xl",
      backdrop: "static",
    });

    modalRef.componentInstance.data = {
      title: " Incomplete User Stories Detected",
      description1:
        incompleteStories.length +
        " of the selected user stories are incomplete and may affect the quality of the generated test cases.",
      description2:
        "Do you want to proceed without including these incomplete user stories?",
      button1Text: "Cancel",
      button2Text: "Proceed Without Incomplete Stories",
      tableData: incompleteStories,
      tableTitle: "Incomplete User Stories",
      columns: userStoryConfirmationTableColumns,
    };

    modalRef.result.then((result: any) => {
      if (result?.value === "success") {
        this.generateTestCases();
      }
    });
  }

  getRandomColor(type: string) {
    const availableColors = this.colors.filter((ele: any) => !ele.used);

    if (availableColors.length === 0) {
      return "";
    }

    const randomIndex = Math.floor(Math.random() * availableColors.length);
    const obj = availableColors[randomIndex];

    const ind = this.colors.findIndex((ele: any) => ele.color === obj.color);
    this.colors[ind].used = true;
    this.colorsByType[type] = obj.color;

    return obj.color;
  }

  downloadGraphAsHTML() {
    console.log(this.filterData.userStory);
    this.isDownloading = true;
    const download$ =
      this.activeType === "storyDriven"
        ? this.restService.downloadKnowledgeGraph(
            this.projectId,
            this.configId,
            {
              selectedStoryKeys: [...this.selectedStories],
              selectedAll: this.isSelectedAll,
              excludedStoryKeys: this.deSelectedStoryKeys,
            }
          )
        : this.restService.downloadUnifiedKnowledgeGraph(
            this.projectId,
            this.configId
          );

    download$.subscribe({
      next: (res: any) => {
        this.isDownloading = false;
        if (!res?.data?.html) {
          console.error("No HTML content found in response");
          return;
        }

        try {
          const blob = new Blob([res.data.html], { type: "text/html" });
          const url = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = "knowledge-graph.html";
          document.body.appendChild(link); // Firefox fix
          link.click();
          document.body.removeChild(link);

          URL.revokeObjectURL(url); // cleanup
        } catch (err) {
          console.error("Error creating or downloading the file:", err);
        }
      },
      error: (err) => {
        this.isDownloading = false;
        console.error("Download failed:", err);
      },
    });
  }
}
